module.exports = __webpack_public_path__ + "static/media/SplitScreenIcon.a31aa574.png";